<template>
  <nav class="navbar">
    <ul class="menubar">
      <li>
        <router-link
          to="/#intro"
          :class="{ reading: intro }"
          id="intro-nav"
          class="leftPartMenu"
          >ARNAQUES 2.0</router-link
        >
      </li>
      <li>
        <router-link
          to="/#fraude-enorme"
          :class="{ reading: ampleur }"
          id="fraude-enorme-nav"
          class="leftPartMenu"
          >Une fraude énorme</router-link
        >
      </li>
      <li>
        <router-link
          to="/#mecanique"
          :class="{ reading: mecanique }"
          id="mecanique-nav"
          class="leftPartMenu"
          >Sa mécanique</router-link
        >
      </li>
      <li>
        <router-link
          to="/#victimes"
          :class="{ reading: victimes }"
          id="victimes-nav"
          class="leftPartMenu"
          >Ses victimes</router-link
        >
      </li>
      <button @click="dropMeDown" class="btn">
        <img src="/img/icon/hamburger.svg" alt="burgermenu" class="btn" />
      </button>
    </ul>
    <progress id="progressbar" class="progress" max="100" value="1"></progress>
    <transition name="fade">
      <div class="dropdown" v-if="dropdown" id="mydropdown">
        <div class="firstline">
          <router-link
            to="/#intro"
            :class="{ reading: intro }"
            id="intro-nav-mobile"
            class="leftPartMenu subcontent_mobile_title"
          >
            <h4 class="subcontent_title">ARNAQUES 2.0</h4>
          </router-link>

          <button class="dropbtn" @click="dropMeDown()"></button>
        </div>
        <div class="subcontent_mobile">
          <div class="subcontent_mobile_sections">
            <li>
              <router-link
                to="/#fraude-enorme"
                :class="{ reading: ampleur }"
                id="fraude-enorme-nav-mobile"
                class="leftPartMenu"
                >Une fraude énorme</router-link
              >
            </li>
            <li>
              <router-link
                to="/#mecanique"
                :class="{ reading: mecanique }"
                id="mecanique-nav-mobile"
                class="leftPartMenu"
                >Sa mécanique</router-link
              >
            </li>
            <li>
              <router-link
                to="/#victimes"
                :class="{ reading: victimes }"
                id="victimes-nav-mobile"
                class="leftPartMenu"
                >Ses victimes</router-link>
            </li>
          </div>
          <div class="apropos_mobile">
            <h4>À propos</h4>
            <p>
              Arnaques.biz est un site pédagogique sur les escroqueries
              financières en ligne.

              <br />Arnaques.biz ne recueille aucune donnée personnelle.
            </p>
          </div>
          <div class="sources_mobile">
            <h4>Sources</h4>
            <p>
              "Mises en garde et listes noires des sociétés et sites non
              autorisés", site internet de l'<a
                target="_blank"
                href="https://www.amf-france.org/fr/espace-epargnants/proteger-son-epargne/listes-noires-et-mises-en-garde"
                >Autorité des marchés financiers.
              </a>
            </p>
            <p>
              Service API du
              <a target="_blank" href="https://www.whoisxmlapi.com/"
                >WhoisXmlApi</a
              >
            </p>
          </div>

          <div class="subcontent_mobile_last_line">
            <p>Wedodata, 2020</p>
          </div>
        </div>
        <div class="subcontent">
          <div class="apropos">
            <h4>À propos</h4>
            <p>
              Arnaques.biz est un site pédagogique sur les escroqueries
              financières en ligne. La collecte des données, la rédaction des
              textes et le développement web du site ont été réalisés par Boris
              Cassel, journaliste économique et développeur web. Le graphisme a
              été imaginé par
              <a target="_blank" href="https://www.behance.net/maelleam"
                >Maëlle Amon-Moreau.</a
              >

              <br />Arnaques.biz ne recueille aucune donnée personnelle.
            </p>
          </div>
          <div class="sources">
            <h4>Sources</h4>
            <p>
              "Mises en garde et listes noires des sociétés et sites non
              autorisés", site internet de l'<a
                target="_blank"
                href="https://www.amf-france.org/fr/espace-epargnants/proteger-son-epargne/listes-noires-et-mises-en-garde"
                >Autorité des marchés financiers.
              </a>
            </p>
            <p>
              Service API du
              <a target="_blank" href="https://www.whoisxmlapi.com/"
                >WhoisXmlApi</a
              >.
            </p>
          </div>
          <div>
            <ContactMe />
          </div>
          <Share />
          <p class="signature_wdd">Réalisé lors d'un stage chez Wedodata en 2020.</p>
        </div>
      </div>
    </transition>
  </nav>
</template>

<script>
import ContactMe from "./ContactHandler";
import Share from "./Share.vue";

export default {
  components: {
    ContactMe,
    Share
  },
  data() {
    return {
      intro: false,
      ampleur: false,
      mecanique: false,
      victimes: false,
      dropdown: false,
      url: "https://wwww.arnaques.biz"
    };
  },

  methods: {
     dropMeDown() {
      if (this.dropdown) {
        this.dropdown = false;

      } else {

        this.dropdown = true;
      }
    }
  },

  created() {
    this.$store.dispatch("loadDate");
    this.$store.dispatch("loadName");
    this.$store.dispatch("loadCategories");

  }
};
</script>

<style>
 /*version stable*/
/*.navbar {
  position: fixed;
  top: 0px;
  font-family: "Open Sans", Helvetica, serif;
  padding-top: 15px;
  width: 100%;
  max-height: 40px;
  z-index: 300;
  background-color: #ffffff;
}

ul.menubar {
  list-style-type: none;
  overflow: hidden;
  margin: 0;
  height: 70%;
}



li .leftPartMenu {
  display: block;
  text-align: center;
  text-decoration: none;
  padding-left: 30px;
  padding-right: 30px;
}

*/
/*version test*/
.navbar {
  position: fixed;
  top: 0px;
  font-family: "Open Sans", Helvetica, serif;
  width: 100%;
  height: 50px;
  z-index: 300;
 /* background-color: red;*/
}

 ul.menubar {
   list-style-type: none;
   overflow: hidden;
   position:relative;
   display:flex;
   align-items:center;
   margin: 0;
   height: 50px;
   background-color: white;
   padding-inline-start: 0;
 }





li .leftPartMenu {
  position:relative;
   display: flex;
   align-items:center;
   justify-content: center;
  text-decoration: none;
   width:200px;
  /* padding-left: 30px;
   padding-right: 30px;*/
  /*background-color: blue;*/
  height:50px;
 }




li {
  float: left;
  color: #2d3562;
}


/* -------- RESPONSIVE : changement menu bar pour mobile ------- */
@media screen and (max-width: 1000px) {
  #intro-nav{
    justify-content: center;
  }


  ul.menubar li:first-child {
    display: block;
  }

  ul.menubar li {
    display: none;
  }
  /*ancienne version nav bar*/
  /*.navbar {
    position: fixed;
    top: 0px;
    font-family: 'Open Sans', Helvetica, serif;
    padding-top: 15px;
    width: 100%;
    max-height: 40px;
    z-index: 300;
  }*/

  li .leftPartMenu {
    position:relative;
    display: flex;
    align-items:center;
    justify-content: flex-start;
    text-decoration: none;
    width:200px;
    /* padding-left: 30px;
     padding-right: 30px;*/
    /*background-color: blue;*/
    height:50px;
  }

  .navbar {
    position: fixed;
    top: 0px;
    font-family: 'Open Sans', Helvetica, serif;
    padding-top: 0;
    width: 100%;
    max-height: 40px;
    z-index: 300;
  }
}

li:visited {
  text-decoration: none;
  color: #2d3562;
}

.router-link-active {
  color: #2d3562;
  font-weight: 700;
}

.btn {
  position: fixed;
  right: 2%;
  top: 10px;
  height: 32.1px;
  width: 24px;
  border: none;
  background-color: white;

}

@media screen and (max-width: 1000px) {
  right: 5%;
}



.dropbutton {
  float: right;
}

/* ----------------------PROGRESS BAR   -------------------------*/
/*version stable*/
 /*progress {
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  width: 100vw;
  height: 4px;
  border: none;
  transition: all 500ms ease-out;
  padding: 0;
  background-color: #ffffff;
  margin: 0;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}*/

/*version essai*/
progress {
   -moz-appearance: none;
   -webkit-appearance: none;
   appearance: none;
   position:relative;
   top:-18px;
   width: 100vw;
   height: 4px;
   border: none;
   transition: all 500ms ease-out;
   padding: 0;
   background-color: #ffffff;
   margin: 0;
   box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
 }


progress::-webkit-progress-bar {
  background-color: white;
}

progress::-webkit-progress-value {
  background-color: #2d3562;
}

progress::-moz-progress-bar {
  background-color: #2d3562;
}

/*########## DROPDOWN##########*/
.dropdown {
  font-family: "Open Sans", Helvetica, sans-serif;
  color: #ffffff;
  position: fixed;
  top: 0px;
  right: 0px;
  z-index: 500;
  width: 50vw;
  height: 100vh;
  background-color: #2d3562;
  text-decoration: none;
}

div.dropdown a {
  font-family: 'Open Sans', Helvetica, serif;
  font-size: 16px;
  font-style: normal;
  line-height: 22px;
  font-weight: 700;
  letter-spacing: 0px;
  text-align: left;
  text-decoration: none;
}

div.dropdown h4 {
  font-weight: 700;
  font-style: normal;
  font-size: 27px;
  line-height: 27.6px;
}

div.dropdown p {
  font-weight: 300;
  font-style: normal;
  font-size: 16px;
  line-height: 18.4px;
}
.dropdown a {
  color: #ffffff;
  text-decoration: none;
}

.dropbtn {
  position: relative;
  margin-left: 3%;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

/*########### mise en place de la première ligne ud droptdown ############*/
.firstline {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 8%;
  width: 90%;
}

.firstline p {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  margin-right: 20px;
  width: 178px;
  height: 28px;
}
.firstline button {
  width: 22.52px;
  height: 22.81px;
  background-image: url("/img/icon/croix.png");
  background-size: cover;
  background-color: #2d3562;
  border: 0px;
  cursor: pointer;
}

/*########### fin mise en place de la première ligne ud droptdown############*/
.subcontent {
  display: flex;
  flex-direction: column;
  margin-left: 6.75%;
  height: 80%;
}
div.apropos p {
  text-justify: none;
  margin-right: 13.34%;
}

div.sources p {
  margin-right: 19%;
}

div.subcontent h4 {
  margin-inline: 0;
  margin-top: 20px;
}

.subcontent_mobile {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-left: 6.75%;
  list-style-type: none;
  width: 65vw;
  height: 90vh;
}

.subcontent_title {
  width: 100%;
}

@media screen and (max-width: 1000px) and (min-width:431px) {
  .dropdown {
    width: 70vw;
    height: 100vh;
  }
  .subcontent {
    display: flex;
    flex-direction:column;
    justify-content: center;
    align-items:center;
    position:relative;
    top:5vh;
    margin:0px;
    height:90vh;
    width:70vw;
  }

  .apropos{
    position:relative;
    display:flex;
    flex-direction: column;
    justify-content:flex-start;
    width:50vw;
    margin:0;
     }

  div.apropos p {
    text-justify:inter-word;
    margin-right: 0;
    text-align:left;
  }


  .sources{
    position:relative;
    display:flex;
    flex-direction: column;
    justify-content:flex-start;
    width:50vw;
    margin:0;
  }

  div.sources p{
    text-justify:inter-word;
    margin-right: 0;
    text-align:left;
  }


  .contactez_auteur{
      position:relative;
      display:flex;
      flex-direction: column;
      justify-content:flex-start;
      width:50vw;
      height:50%;
      margin-top:5vh;
      }

  div.subcontent div.footer_partagez{
    position:relative;
    display:flex;
    flex-direction: column;
    justify-content:flex-start;
    width:50vw;
    align-self:center;
    height: 100%;
  }

}




/*------- subcontent mobile ----*/
@media screen and (min-width: 1001px) {
  .subcontent_mobile {
    display: none;
  }
}

@media screen and (max-width: 1000px) {
  .dropdown {
    width: 75vw;
  }

  div.dropdown a {
    font-family: 'Open Sans', Helvetica, serif;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 25px;
    letter-spacing: 0px;
    text-align: left;
  }

  div.dropdown p {
    font-family: 'Open Sans', Helvetica, serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 19px;
    letter-spacing: 0px;
    text-align: left;
    padding-left: 10px;
  }

  div.sources_mobile a {
    font-size: 14px;

  }



  #intro-nav.router-link-active,
  #mecanique-nav-mobile.router-link-active,
  #fraude-enorme-nav-mobile.router-link-active,
  #victimes-nav-mobile.router-link-active,
  .router-link-exact-active {
    font-weight: 700;
  }




  div.apropos_mobile h4,
  div.sources_mobile h4 {
    font-family: 'Open Sans', Helvetica, serif;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 25px;
    letter-spacing: 0px;
    text-align: left;
    padding-left: 10px;
  }

  .subcontent {
    display: none;
  }

  .subcontent_mobile_sections {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    width: 100%;
    height: 15vh;
    margin-bottom: 5vh;
  }

  .subcontent_mobile_last_line {
    position:relative;
    bottom:5px;
    display: flex;
    justify-content: flex-end;
    margin-top: 5vh;
    align-items: flex-end;
  }

 }

/*######## PARATGEZ######*/
.iconPartage {
  background-size: cover;
  width: 24px;
  height: 24px;
  background-color: #2d3562;
  border: 0;
  cursor: pointer;
}

.twitter {
  background-image: url("/img/icon/Twitter_w.png");
}

.facebook {
  background-image: url("/img/icon/Facebook_w.png");
}

/*##################DERNIERE LIGNE HAMBURGER##########@*/
.signature_wdd {
  position: fixed;
  width: 400px;
  height: 16px;
  right: 0px;
  bottom: 10px;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: #ffffff;
}
</style>
